import * as React from 'react';
import { SVGProps } from 'react';

const IconBookSizeM = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path d="M5 4a1 1 0 0 1 1-1h1v9l2-1 2 1V3h6a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H8a1 1 0 0 0 0 2h10a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V4Z" />
  </svg>
);
export default IconBookSizeM;
